<div>
  @if (showAdditionalEditOptions) {
    <div class="spacing-elements">
      <coin-color-picker [(ngModel)]="item.backgroundColor"></coin-color-picker>
    </div>
    <coin-email-slider
      label="Space-Top"
      [(ngModel)]="item.paddingTop"></coin-email-slider>
    <coin-email-slider
      label="Space-Bottom"
      [(ngModel)]="item.paddingBottom"></coin-email-slider>
    <coin-email-slider
      label="Font size"
      [(ngModel)]="item.fontSize"></coin-email-slider>
  }
  @for (linkItem of item.content; track linkItem) {
    <div class="download-file-item">
      <img
        class="download-file-icon"
        aria-label="download icon"
        [src]="imagePath + 'coin/images/originals/download_icon_SE.png'" />
      @if (contentEdit) {
        <coin-v2-text-input
          [label]="'cms.content-pages.link-text' | translate"
          [(ngModel)]="linkItem.text" />
      }
      @if (contentEdit) {
        <coin-v2-text-input
          [label]="'cms.content-pages.link-href' | translate"
          [placeholder]="'cms.content-pages.link-href-placeholder' | translate"
          [(ngModel)]="linkItem.link" />
      }
      @if (!contentEdit) {
        <a
          class="flex-one"
          target="_blank"
          [href]="linkItem.link">
          {{ linkItem.text }}
        </a>
      }
    </div>
  }
</div>

@if (contentEdit) {
  <div class="download-file-edit">
    <mat-form-field appearance="fill">
      <mat-label>{{ 'cms.amount-links' | translate }}</mat-label>
      <mat-select
        [(ngModel)]="amountLinks"
        (selectionChange)="amountChange($event.value)">
        @for (option of amountOptions; track option) {
          <mat-option [value]="option">{{ option }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (isContentPage) {
      <coin-v2-checkbox
        [label]="'cms.content-pages.requires-authentication' | translate"
        [(ngModel)]="item.requiresAuthentication" />
    }
  </div>
}
